var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back_page",on:{"click":_vm.back}},[_c('div',{staticClass:"back"},[(!_vm.hidBack)?_c('i',{staticClass:"icon"}):_vm._e()]),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }